<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    right
    width="450"
    height="100%"
    app
  >
    <v-card
      v-if="drawer && item"
      flat
      :loading="loading"
    >
      <v-card-text>
        <v-icon @click="drawer = false"> close </v-icon>
      </v-card-text>
      <v-card-title> {{ title }}</v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-row>
            <v-col
              v-if="item.category"
              cols="12"
            >
              <v-autocomplete
                v-model="item.category.id"
                :items="categoriesToShow"
                :rules="[$rules.required]"
                label="Category"
                outlined
                hide-details="auto"
                item-value="id"
                item-text="name"
                :disabled="disableCategory || !isAdd"
              />
            </v-col>
            <v-col
              v-if="item.designGroup"
              cols="12"
            >
              <v-autocomplete
                v-model="item.designGroup.id"
                :items="design_groups"
                :rules="[$rules.required]"
                label="Design Group"
                outlined
                hide-details="auto"
                item-value="id"
                item-text="name"
                :disabled="disableDesignGroup || !isAdd"
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="item.notes"
                label="Notes"
                outlined
                hide-details="auto"
                auto-grow
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <EditPage />
    </v-card>
    <template #append>
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          block
          large
          :loading="saving"
          @click="save"
        >
          Save
        </v-btn>
        <v-btn
          v-if="!catalogContentPageId"
          color="primary"
          outlined
          block
          large
          :loading="saving"
          class="mt-2"
          @click="addCatalogContentPage"
        >
          Add Catalog Page
        </v-btn>
        <v-btn
          v-else
          color="primary"
          outlined
          block
          large
          :loading="saving"
          class="mt-2"
          @click="editCatalogContentPage"
        >
          Edit Catalog Page
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';
import EditPage from '@/components/content/catalog/EditPage';

export default {
  name: 'EditDesignGroupCategory',

  components: { EditPage },

  data() {
    return {
      loading: false,
      valid: false,
      saving: false,
      drawer: false,
      disableCategory: false,
      disableDesignGroup: false
    };
  },

  computed: {
    title() {
      return this.isAdd ? 'Add Design Group Category' : 'Edit Design Group Category';
    },
    isAdd() {
      return !this.item.id;
    },
    categoriesToShow() {
      let list = this.categories;

      if (this.isAdd && !this.disableCategory) {
        const existingCategoryIds = (this.designgroup.categories || []).map((x) => x.category.id);
        list = list.filter((x) => !existingCategoryIds.includes(x.id));
      }

      return list;
    },
    item: {
      get() {
        return this.$store.getters['designgroups/edit_designgroup_category'];
      },
      set(val) {
        this.$store.dispatch('designgroups/editCategory', val);
      }
    },
    catalogContentPageId() {
      return this.catalog_content_pages.filter(x => x.designGroupId === this.designgroup.id && x.categoryId === this.item.category.id).map(x => x.id)[0];
    },
    ...mapGetters({
      designgroup: 'designgroups/designgroup',
      design_groups: 'lookup/design_groups',
      categories: 'lookup/categories',
      catalog_content_pages: 'lookup/catalog_content_pages'
    })
  },

  async mounted() {
    this.$bus.$off(this.$enums.EVENT_BUS_EVENTS.DESIGN_GROUP_CATEGORY_SHOW);
    this.$bus.$on(this.$enums.EVENT_BUS_EVENTS.DESIGN_GROUP_CATEGORY_SHOW, (data) => {
      this.loadData(data);
      this.disableCategory = !!data.categoryId;
      this.disableDesignGroup = !!data.designGroupId;
      this.drawer = true;
    });
  },

  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      this.$store
        .dispatch('designgroups/updateCategory', this.item)
        .then(() => {
          this.drawer = false;
          this.$root.$snackbarSuccess('Design Group Category saved');
          this.$emit('save');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    loadData(data) {
      this.loading = true;
      Promise.all([
        this.$store.dispatch('designgroups/getCategory', {
          designGroupId: data.designGroupId,
          categoryId: data.categoryId
        })
      ])
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addCatalogContentPage() {
      this.saving = true;
      this.$store
        .dispatch('designgroups/addCatalogContentPage', {
          designGroupId: this.item.designGroup.id,
          categoryId: this.item.category.id
        })
        .then(() => {
          this.drawer = false;
          this.$root.$snackbarSuccess('Page added');
          this.$emit('save');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    editCatalogContentPage() {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.EDIT_CATALOG_PAGE_SHOW, {
        id: this.catalogContentPageId
      });
    }
  }
};
</script>
